import { AxiosRequestConfig, AxiosResponse } from 'axios';
import $http from 'services/http.service';
import { clientId, codeChallenge, codeChallengeMethod, redirectUri, responseType } from 'utils/helper.utils';

type LoginData = {
  email: string;
  password: string;
  keepLoggedIn: boolean;
};

export async function login(data: LoginData, requestOptions: AxiosRequestConfig<LoginData> = {}): Promise<AxiosResponse<LoginResponse>> {
  const response = await $http.post('/login', data, {
    headers: {
      'client-id': clientId,
      'redirect-uri': redirectUri,
      'response-type': responseType,
      ...(codeChallenge ? { 'code-challenge': codeChallenge } : {}),
      ...(codeChallengeMethod ? { 'code-challenge-method': codeChallengeMethod } : {})
    },
    ...requestOptions
  });
  return response;
}

type AuthorizeResponse = {
  refreshToken: string | null;
  accessToken: string | null;
  code: string | null;
  auth: boolean;
};

export async function authorize(authCode: string): Promise<AxiosResponse<AuthorizeResponse>> {
  const data = { authCode };
  const response = await $http.post<AuthorizeResponse>('/authorize', data, {
    headers: {
      'client-id': clientId,
      'redirect-uri': redirectUri,
      'response-type': responseType,
      ...(codeChallenge ? { 'code-challenge': codeChallenge } : {}),
      ...(codeChallengeMethod ? { 'code-challenge-method': codeChallengeMethod } : {})
    }
  });

  return response;
}
